var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error" }, [
    _c("div", { staticClass: "main-logo" }, [_vm._v(" 九航工作后台管理系统 ")]),
    _c("div", { staticClass: "error-main" }, [
      _c("div", { staticClass: "err-reason" }, [
        _vm._v(
          _vm._s(
            (_vm.errorMap[_vm.errorCode] &&
              _vm.errorMap[_vm.errorCode].message) ||
              "请求失败"
          )
        ),
      ]),
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 不要着急，你可以返回 "),
        _c("a", { staticClass: "click-page", on: { click: _vm.back } }, [
          _vm._v("上一页"),
        ]),
        _vm._v("或 "),
        _c("a", { staticClass: "click-page", on: { click: _vm.toHome } }, [
          _vm._v("首页"),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }